<script lang="ts" setup>
    import useCpBem from '~/composables/useCpBem';
    import CpText from '~/components/cp/CpText/CpText.vue';

    withDefaults(
        defineProps<{
            /** Custom description */
            kind?: 'standard'|'sortBy'|'filter'
            radioText: string
            filterCounter?: number
            selected: boolean
            value: string
        }>(), {
            kind: 'standard',
        },
    );

    defineEmits({
        'update:model-value': null,
    });

    const {b, e, em} = useCpBem('cp-radio-button');
</script>

<template>
    <div :class="b">
        <v-radio
            :value="value"
        >
            <template #label>
                <div :class="e('text-box')">
                    <CpText :variant="selected ? 'body-bold' : 'body-regular'" type="primary">
                        {{ radioText }}
                    </CpText>
                </div>
            </template>
        </v-radio>
        <CpText
            v-if="kind==='filter'"
            :class="em(`text`, {caption: true})"
            :type="!selected ? 'neutral' : 'neutral-dark'"
            variant="caption-bold"
        >
            {{ filterCounter }}
        </CpText>
    </div>
</template>

<style lang="scss">
    .cp-radio-button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__container {
            display: flex;
            align-items: center;
        }
        &__icon {
            margin-right: 5px;
            cursor: pointer;
        }
        &__text{
            margin-top: 1px;
            &--caption {
                margin-top: 2px;
            }
        }
        &__adjust-icon {
            margin-bottom: 1px;
        }
    }
    .v-label {
      color: var(--color-primary);
      opacity: 1;
      font-family: var(--cp-font-family);
      font-weight: var(--cp-regular);
      font-size: var(--cp-body-regular-size);
      line-height: var(--cp-body-regular-line-height);
    }
    .v-selection-control__wrapper {
      width: 24px;
      margin-right: 5px;
    }
    .v-selection-control__input {
      color: var(--color-primary);
      opacity: 1;
    }
    .v-selection-control {
      &__input {
        > .v-icon {
          opacity: 1;
        }
      }
    }
</style>
